
/**
 * 复选框组控件
 * wangj
 */


const SgiCheckBoxEO = () => ({
    isBtn: true,
    checked: ['1', ''],
    c: "col2",
    ctlH: 0,
    ctlN: "单选框",
    ctlW: 600,
    desId: "EP_EO_UI_3108",
    isDis: false,
    isHdn: false,
    lblAlg: "left",
    lblW: 200,
    n: "字段2",
    sNo: 0,
    scId: 'SD_SC_PT_0001',//标准代码GUID
    t: "radio",
    te: '复选框控件',
    ctlClu: 1,
    useCodes: '',

    // alwBlk : true,
    // isGw : false,
    // isLbl : true,
    // isRead : false,
    // isSrp : true,

    // maxL : 0,
    // minL : 0,
    // msfTgt : "qtip",
    // useTim : 0,
    // visible : true,
    // x : "0",
    // y : "0",



});

export { SgiCheckBoxEO };
export default SgiCheckBoxEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiCheckBoxEO.js